import { render } from "./BaseButton.vue?vue&type=template&id=01ec9823"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "01ec9823"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01ec9823', script)) {
    api.reload('01ec9823', script)
  }
  
  module.hot.accept("./BaseButton.vue?vue&type=template&id=01ec9823", () => {
    api.rerender('01ec9823', render)
  })

}

script.__file = "src/ui/buttons/BaseButton.vue"

export default script